(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
	});

	initProductAccordion();
	initZoomImage();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);

const humblerGalleryDesktopQuery = window.matchMedia("(min-width: 1024px)");

/* Gallery: desktop = static 2-col grid; mobile = native scroll-snap carousel
   with CRAFTD-style page dots (no Swiper). */
const initHumblerProductGallery = () => {
	document
		.querySelectorAll(".humbler-product-gallery__swiper")
		.forEach((gallery) => {
			const root = gallery.closest(".humbler-product-gallery");
			if (!root) return;
			if (gallery.swiper) gallery.swiper.destroy(true, true);

			if (humblerGalleryDesktopQuery.matches) {
				root.classList.add("humbler-product-gallery--grid");
				root.classList.remove("humbler-product-gallery--snap");
				return;
			}

			root.classList.remove("humbler-product-gallery--grid");
			root.classList.add("humbler-product-gallery--snap");

			const wrapper = gallery.querySelector(".swiper-wrapper");
			const slides = [...gallery.querySelectorAll(".humbler-product-gallery__slide")];
			const dots = gallery.querySelector(".humbler-product-gallery__pagination");
			if (!wrapper) return;

			// Always open on the first slide: kill restored/anchored scroll positions.
			wrapper.scrollLeft = 0;
			if (!wrapper.dataset.hbScrollGuard) {
				wrapper.dataset.hbScrollGuard = "1";
				let hbUserScrolled = false;
				["pointerdown", "touchstart", "wheel"].forEach((ev) => {
					wrapper.addEventListener(ev, () => { hbUserScrolled = true; }, { passive: true, once: true });
				});
				window.addEventListener("load", () => {
					if (!hbUserScrolled) wrapper.scrollLeft = 0;
				});
			}

			if (!dots || slides.length < 2 || dots.dataset.hbDots) return;
			dots.dataset.hbDots = "1";
			dots.classList.add("hb-page-dots");
			dots.innerHTML = "";
			slides.forEach((slide, i) => {
				const dot = document.createElement("button");
				dot.type = "button";
				dot.className = "hb-dot";
				dot.setAttribute("aria-label", "Go to item " + (i + 1));
				dot.setAttribute("aria-current", i === 0 ? "true" : "false");
				dot.addEventListener("click", () => {
					wrapper.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
				});
				dots.appendChild(dot);
			});
			const syncDots = () => {
				const mid = wrapper.scrollLeft + wrapper.clientWidth / 2;
				let index = 0;
				let best = Infinity;
				slides.forEach((slide, i) => {
					const center = slide.offsetLeft + slide.offsetWidth / 2;
					const dist = Math.abs(center - mid);
					if (dist < best) { best = dist; index = i; }
				});
				[...dots.children].forEach((dot, i) => {
					dot.setAttribute("aria-current", i === index ? "true" : "false");
				});
			};
			wrapper.addEventListener(
				"scroll",
				() => window.requestAnimationFrame(syncDots),
				{ passive: true }
			);
		});
};

const initLegacyProductGallery = () => {
	if (typeof Swiper === "undefined") {
		window.setTimeout(initLegacyProductGallery, 50);
		return;
	}

	document.querySelectorAll(".js-media-list").forEach((mediaList) => {
		if (mediaList.swiper) return;

		new Swiper(mediaList, {
			loop: true,
			slidesPerView: "auto",
			centeredSlides: true,
			pagination: {
				el: mediaList.querySelector(".swiper-pagination") || ".swiper-pagination",
				type: "fraction",
			},
			navigation: {
				nextEl: mediaList.querySelector(".swiper-button-next") || ".swiper-button-next",
				prevEl: mediaList.querySelector(".swiper-button-prev") || ".swiper-button-prev",
			},
		});
	});
};

document.addEventListener("shopify:section:load", () => {
	initHumblerProductGallery();
	initLegacyProductGallery();
});

humblerGalleryDesktopQuery.addEventListener("change", initHumblerProductGallery);

initHumblerProductGallery();
initLegacyProductGallery();

/* CRAFTD-style metal swatch cards: swap Globo color dots for product-image tiles with labels */
const upgradeGloboSwatches = (root) => {
	root.querySelectorAll(".gsw-prg-item--link").forEach((link) => {
		if (link.dataset.hbUpgraded) return;
		const swatch = link.querySelector(".swatch-anchor");
		if (!swatch) return;
		link.dataset.hbUpgraded = "1";
		if (link.dataset.image) {
			swatch.style.backgroundImage = "url(" + link.dataset.image + ")";
		}
		if (link.dataset.title && !link.querySelector(".hb-swatch-label")) {
			const label = document.createElement("span");
			label.className = "hb-swatch-label";
			label.textContent = link.dataset.title.toLowerCase();
			link.appendChild(label);
		}
	});
};

/* Globo's admin config has literal "<b>Metal: </b>" typed into the option-name
   field; some render paths escape it and print the tags as text. Rebuild every
   legend as a clean "LABEL: VALUE" regardless of which path the app took. */
const cleanGloboLegends = (root) => {
	root.querySelectorAll(".gsw-item-product-group legend").forEach((legend) => {
		const raw = (legend.textContent || "").replace(/<[^>]*>/g, " ");
		const cleaned = raw.replace(/\s+/g, " ").trim();
		if (!cleaned) return;
		const idx = cleaned.indexOf(":");
		const label = (idx > 0 ? cleaned.slice(0, idx) : cleaned).trim();
		const value = idx > 0 ? cleaned.slice(idx + 1).replace(/[:\s]+/g, " ").trim() : "";
		if (legend.dataset.hbLegend === label + "|" + value) return;
		legend.dataset.hbLegend = label + "|" + value;
		legend.textContent = "";
		const b = document.createElement("b");
		b.textContent = label + ": ";
		const name = document.createElement("span");
		name.className = "name";
		name.textContent = value;
		legend.appendChild(b);
		legend.appendChild(name);
	});
};

const globoHosts = new Map();
const globoSelector = ".globo-product-groups-detail, .gsw-item-product-group, .gsw-prg-item--link";
const observeGloboHost = (host) => {
	if (globoHosts.has(host)) return;
	const state = {frame: null};
	const refresh = () => {
		state.frame = null;
		if (!host.isConnected) return;
		upgradeGloboSwatches(host);
		cleanGloboLegends(host);
	};
	const observer = new MutationObserver((records) => {
		const relevant = records.some((record) => {
			const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
			if (target?.closest(globoSelector)) return true;
			return Array.from(record.addedNodes).some((node) => node.nodeType === 1 && (node.matches(globoSelector) || node.querySelector(globoSelector)));
		});
		if (relevant && state.frame === null) state.frame = requestAnimationFrame(refresh);
	});
	state.observer = observer;
	globoHosts.set(host, state);
	observer.observe(host, {subtree: true, childList: true, characterData: true});
	refresh();
};
const initGloboHosts = () => {
	globoHosts.forEach((state, host) => {
		if (host.isConnected) return;
		state.observer.disconnect();
		if (state.frame !== null) cancelAnimationFrame(state.frame);
		globoHosts.delete(host);
	});
	document.querySelectorAll('[id^="ProductInfo-"]').forEach(observeGloboHost);
};
document.addEventListener("shopify:section:load", initGloboHosts);
document.addEventListener("shopify:section:unload", (event) => {
	globoHosts.forEach((state, host) => {
		if (!event.target.contains(host)) return;
		state.observer.disconnect();
		if (state.frame !== null) cancelAnimationFrame(state.frame);
		globoHosts.delete(host);
	});
});
initGloboHosts();

/* Desktop gallery lightbox: click a tile to view the image large; close with X, backdrop, or Esc */
const initHumblerLightbox = () => {
	if (document.querySelector(".hb-lightbox")) return;
	const lightbox = document.createElement("div");
	lightbox.className = "hb-lightbox";
	lightbox.setAttribute("hidden", "");
	lightbox.innerHTML =
		'<div class="hb-lightbox__backdrop"></div>' +
		'<figure class="hb-lightbox__figure"><img class="hb-lightbox__img" alt=""></figure>' +
		'<button type="button" class="hb-lightbox__close" aria-label="Close">&#215;</button>';
	document.body.appendChild(lightbox);

	const bigImg = lightbox.querySelector(".hb-lightbox__img");
	const closeLightbox = () => {
		lightbox.setAttribute("hidden", "");
		document.documentElement.classList.remove("hb-lightbox-open");
	};
	lightbox.querySelector(".hb-lightbox__backdrop").addEventListener("click", closeLightbox);
	lightbox.querySelector(".hb-lightbox__close").addEventListener("click", closeLightbox);
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && !lightbox.hasAttribute("hidden")) closeLightbox();
	});

	document.addEventListener("click", (e) => {
		const tileImg = e.target.closest(".humbler-product-gallery--grid .humbler-product-gallery__image");
		if (!tileImg) return;
		bigImg.src = tileImg.src;
		bigImg.alt = tileImg.alt || "";
		lightbox.removeAttribute("hidden");
		document.documentElement.classList.add("hb-lightbox-open");
	});
};

initHumblerLightbox();
